<template>
	<el-dropdown size="small" class="d2-mr">
		<span class="btn-text">{{info ? `你好 ${info}` : '未登录'}}</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item @click.native="logOff">
				<d2-icon name="power-off" class="d2-mr-5" />
				注销
			</el-dropdown-item>
			<el-dropdown-item @click.native="personalInformation">
				<i class="el-icon-user"></i>
				个人信息
			</el-dropdown-item>
			<el-dropdown-item @click.native="isshow = true">
				<i class="el-icon-user"></i>
				修改密码
			</el-dropdown-item>
		</el-dropdown-menu>

		<el-dialog title="个人信息" :visible.sync="openstate" :before-close="handleClose">
			<div style='padding: 20px;'>
				<el-row :gutter="15">
					<el-form ref="formData" :model="formData" :rules="rules" size="mini" label-width="160px"
						label-position="left">
						<el-col :span="24">
							<el-form-item label="联系人" size='mini' prop='linkman'>
								<el-input v-model.trim="formData.linkman" placeholder="请输入联系人"></el-input>
							</el-form-item>
							<el-form-item label="联系方式" size='mini' prop='phone'>
								<el-input v-model.trim="formData.phone" placeholder="请输入联系方式"></el-input>
							</el-form-item>
							<el-form-item label="邮箱" size='mini' prop='email'>
								<el-input v-model.trim="formData.email" placeholder="请输入邮箱地址"></el-input>
							</el-form-item>
							<el-form-item label="头像" size='mini' prop='name'>
								<el-upload class="avatar-uploader" :action="field113Action" :show-file-list="false"
									:headers="token" :on-success="handleAvatarSuccess1" :before-upload="beforeUpload">
									<img v-if="imageUrl1" :src="imageUrl1" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
								<!-- <img :src="baseUrl + formData.image" alt="" style="width:200px;height:200px"> -->
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item size="large">
								<el-button type="primary" @click="submitForm">确认修改</el-button>
								<el-button @click="resetForm">关闭</el-button>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
			</div>
		</el-dialog>

		<el-dialog title="修改密码" :visible.sync="isshow" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form ref="phoneloginForm" label-position="top" :rules="newrules" :model="phoneform" size="default">
				<el-form-item prop="password" class="topinput">
					<el-input  v-model="phoneform.password" placeholder="原密码">
						<i slot="prepend" class="fa fa-user-circle-o"></i>
					</el-input>
				</el-form-item>
				<el-form-item prop="newPassword" class="topinput">
					<el-input  v-model="phoneform.newPassword" placeholder="新密码">
						<i slot="prepend" class="fa fa-user-circle-o"></i>
					</el-input>
				</el-form-item>
				<el-form-item prop="newPassword1" class="topinput">
					<el-input type="password" v-model="phoneform.newPassword1" placeholder="再次输入新密码">
						<i slot="prepend" class="fa fa-user-circle-o"></i>
					</el-input>
				</el-form-item>
				<el-form-item class="topinput">
					<el-button class="topinput" size="default" @click="phonesubmit" type="primary">
						确定修改
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</el-dropdown>
</template>

<script>
	import {
		dealerFindOne,
		userpassword,
		dealerUpdateInfo
	} from '@/request/api';
	import util from '@/libs/util'
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		computed: {
			...mapState('d2admin/user', [
				'info'
			])
		},
		data() {
			return {
				info: '',
				openstate: false,
				formData: {},
				rules: {},
				phoneform: {
					password: '',
					newPassword: '',
					newPassword1:''
				},
				newrules: {
					password: [{
						required: true,
						// validator: checkphone,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					newPassword: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					newPassword1: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
				},
				baseUrl: "",
				field113Action: '',
				token: {
					token: ''
				},
				imageUrl1: '',
				imageUrl1s: "",
				isshow: false
			}
		},
		created() {
			this.info = util.cookies.get('name');
			this.token.token = util.cookies.get('distributor_token')
			this.baseUrl = baseUrl
			this.field113Action = UploadAddress
		},
		methods: {
			...mapActions('d2admin/account', [
				'logout'
			]),
			/**
			 * @description 登出
			 */
			logOff() {
				this.logout({
					confirm: true
				})
			},
			submitForm() {
				this.formData.image = this.imageUrl1s
				dealerUpdateInfo(this.formData).then(res => {
					if (res.success) {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.openstate = false
						window.location.href = '#/refresh';
					} else {
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			phonesubmit(){
			  this.$refs.phoneloginForm.validate((valid) => {
			    if (valid) {
					if(this.phoneform.newPassword!=this.phoneform.newPassword1){
						this.$message({
						  message: '两次输入的密码不一致',
						  type: 'error'
						});
					}else{
						userpassword({
						  password: this.phoneform.password,
						  newPassword: this.phoneform.newPassword
						}).then(res => {
						  if (res.code == 0) {
						    this.isshow = false
						    this.$message({
						      message:'修改成功',
						      type: 'success'
						    });
							window.location.href = '#/login';
							util.cookies.remove('distributor_token')
						  } else {
						    this.getvcode()
						    console.log("接口失败", res)
						    this.$message({
						      message: res.message,
						      type: 'error'
						    });
						  }
						})
					}
			    } else {
			      // 登录表单校验失败
			      this.$message.error('表单校验失败，请检查')
			    }
			  })
			},
			handleAvatarSuccess1(res, file) {
				this.imageUrl1 = this.baseUrl + res.data.entity.path
				this.imageUrl1s = res.data.entity.uuid
			},
			personalInformation() {
				dealerFindOne({
					uuid: util.cookies.get('dealerUuid'),
				}).then(res => {
					if (res.success) {
						this.formData = res.data.yxDealer
						this.imageUrl1 = this.baseUrl + res.data.yxDealer.image
						this.openstate = true
					}
				})
			},
			swithphone() {
				this.isshow = true
			},
			resetForm() {
				this.openstate = false
				window.location.href = '#/refresh';
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						window.location.href = '#/refresh';
						done();
					})
					.catch(_ => {});
			},
			beforeUpload(file) {
				let isRightSize = file.size / 1024 / 1024 < 2
				if (!isRightSize) {
					this.$message.error('文件大小超过 2MB')
				}
				return isRightSize
			},
		}
	}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
